import { getDateWithoutTimezone } from '../../utils';
import { ChartContext } from '../interface';

export const createVolatilitySeries = (
  assetQuotes: ChartContext.IAssetQuotes[] | undefined
): Highcharts.SeriesOptionsType[] => {
  if (!assetQuotes) return [];

  const periods = 21;
  let devPad: any[] | null | number = null;

  const series = assetQuotes.map((item) => {
    const quotesLength = item.quotes.length;
    const seriesChart: any[] = [];

    for (let i = periods; i < quotesLength; i++) {
      const quotesPerPeriod = item.quotes.slice(i - periods, i + 1);

      devPad = rateOfChange(quotesPerPeriod);
      devPad = Math.sqrt(getVariance(devPad)) * Math.sqrt(252);

      if (!isNaN(devPad))
        seriesChart.push([getDateWithoutTimezone(item.quotes[i].d), devPad]);
    }

    return {
      lineWidth: 1.5,
      opacity: 0.8,
      ...item,
      data: seriesChart,
      name: item.shortname || item.nicename || item.name,
      id: item.id,
      color: item.color,
      type: 'line' as any,
    };
  });

  return series;
};

const rateOfChange = (arrayQuotes: ChartContext.IQuotes): any[] => {
  const roc: any[] = [];
  const quotesLength = arrayQuotes.length;

  for (let index = 0; index < quotesLength; index++) {
    const quote = arrayQuotes[index]?.c || (arrayQuotes[index]?.q as number);
    const quotePrev =
      arrayQuotes[index - 1]?.c || (arrayQuotes[index - 1]?.q as number);

    if (index > 0) {
      roc.push(((quote - quotePrev) / quotePrev) * 100);
    }
  }

  return roc;
};

const getVariance = (numArr: number[]) => {
  const avg = numArr.reduce((a, b) => a + b) / numArr.length;

  let i = numArr.length;
  let v: any = 0;

  while (i--) {
    v += Math.pow(numArr[i] - avg, 2);
  }

  v /= numArr.length;

  return v;
};
